import { PayoutApiClient } from '@fourthwall/services/dist/PayoutApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const usePayoutTransactionsQuery = createQueryHook(PayoutApiClient.getPayoutTransactions, {
  queryKey: ['payoutTransactions'],
})
